import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "../App.css";
import Footer from "../components/Footer";

const Contact = () => {
    const form = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [statusMessage, setStatusMessage] = useState(null);
    const [lastSentTime, setLastSentTime] = useState(0);

    const sendEmail = (e) => {
        e.preventDefault();

        // Bot Honeypot Check
        const honeypot = form.current["_gotcha"]?.value;
        if (honeypot) {
            console.warn("Spam detected via honeypot.");
            return;
        }

        // Rate limiting cooldown (30 seconds between sends)
        const now = Date.now();
        if (now - lastSentTime < 30000) {
            setStatusMessage({ type: "error", text: "Please wait 30 seconds before sending another inquiry." });
            return;
        }

        setIsSubmitting(true);
        setStatusMessage({ type: "info", text: "Dispatching your message to our marine operations team..." });

        emailjs
            .sendForm(
                "service_v7xwleq",
                "template_b9dzc2b",
                form.current,
                "nY-PyzSMsXXjQl2Id"
            )
            .then(
                () => {
                    setStatusMessage({ type: "success", text: "Thank you! Your inquiry has been dispatched to our operations team. We will respond within 2 hours." });
                    form.current.reset();
                    setLastSentTime(Date.now());
                    setIsSubmitting(false);
                },
                (error) => {
                    console.error("EmailJS Error:", error);
                    setStatusMessage({ type: "error", text: "Direct dispatch encountered an issue. Please call +94 719 745 745 or email info@bluewavesshipmanagement.com." });
                    setIsSubmitting(false);
                }
            );
    };

    return (
        <>
            <section id="contact" className="contact-section">
                <div className="contact-container">
                    {/* Contact Info */}
                    <div>
                        <h2 className="contact-heading">Get in Touch</h2>
                        <p className="contact-paragraph">
                            "We're here to help 24/7. Have a question about our afloat ship repairs, drydock management, or marine technical services? Our superintendents are ready to assist you immediately."
                        </p>
                        <div className="contact-info">
                            <p>📍 <strong>Headquarters:</strong> No 199/1/H, Rathmaldiniya Temple Road, Erewwela, Pannipitiya, Colombo, Sri Lanka.</p>
                            <p>⚓ <strong>Operational Ports:</strong> Port of Colombo (LKCMB) • Galle (LKGLE) • Hambantota (LKHAM)</p>
                            <p>📞 <strong>Phone:</strong> <a href="tel:+94719745745">+94 719 745 745</a> (24/7 Maritime Desk)</p>
                            <p>✉️ <strong>Email:</strong> <a href="mailto:info@bluewavesshipmanagement.com">info@bluewavesshipmanagement.com</a></p>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="contact-form">
                        <h3>Send Us a Message</h3>
                        <form ref={form} onSubmit={sendEmail}>
                            {/* Hidden Bot Honeypot */}
                            <input type="text" name="_gotcha" style={{ display: "none" }} tabIndex="-1" autoComplete="off" />

                            <input type="text" name="name" placeholder="Your Name / Company" required />
                            <input type="email" name="email" placeholder="Your Official Email" required />
                            <input type="text" name="subject" placeholder="Subject / Vessel IMO / Service Required" required />
                            <textarea name="message" rows="5" placeholder="Specify your requirements, port location, timeline, and vessel specifications" required></textarea>

                            <button type="submit" disabled={isSubmitting} style={{ cursor: isSubmitting ? "not-allowed" : "pointer", opacity: isSubmitting ? 0.7 : 1 }}>
                                {isSubmitting ? "Sending..." : "Send Message"}
                            </button>

                            {statusMessage && (
                                <p style={{
                                    marginTop: "1rem",
                                    padding: "0.75rem 1rem",
                                    borderRadius: "8px",
                                    fontSize: "0.9rem",
                                    background: statusMessage.type === "success" ? "#ecfdf5" : statusMessage.type === "info" ? "#eff6ff" : "#fef2f2",
                                    color: statusMessage.type === "success" ? "#065f46" : statusMessage.type === "info" ? "#1e40af" : "#991b1b",
                                    border: `1px solid ${statusMessage.type === "success" ? "#a7f3d0" : statusMessage.type === "info" ? "#bfdbfe" : "#fecaca"}`
                                }}>
                                    {statusMessage.text}
                                </p>
                            )}
                        </form>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default Contact;
